import { call, put } from "redux-saga/effects";
import {
  findGeoLocations,
  getRecentLocations,
  postRecentLocation,
  getIpLocation,
} from "../../api/geoSearchApi";
import { Types } from "../actionTypes";
import { setCookie, getCookie } from "@Src/utils/cookie.utils";
import { formatSuggestedLocation } from "../../utils/location.utils";
import { getLanguageFromLocation } from "@Src/components/Language/LanguageByLocationMap";
import { IP_LOCATION_COOKIE, LANGUAGE_COOKIE } from "@Src/constants";

import actions from "@Src/redux/rootActions";

const { updateLanguage } = actions.language;

export function* doGeoSearch(action) {
  try {
    const response = yield call(findGeoLocations, action.params);

    yield put({ type: Types.FETCH_GEO_LOCATION_RESULTS_SUCCESS, response });
  } catch (e) {
    yield put({ type: Types.FETCH_GEO_LOCATION_RESULTS_FAILURE });
    console.log("error: ", e);
  }
}

export function* doGetGeoLocationDetails(action) {
  // type should equal one of ["searchLocation", "defaultLocation"]
  const { params, type } = action;

  try {
    // break this down here so it's consumable everywhere it's needed.
    const locationObj = formatSuggestedLocation(params);

    yield put({
      type: Types.FETCH_GEO_LOCATION_DETAILS_SUCCESS,
      locationObj,
    });

    if (type === "defaultLocation") {
      // set as defaultLocation
      yield put({
        type: Types.SET_DEFAULT_LOCATION,
        locationObj,
      });
    } else {
      // type === "searchLocation"
      // set as currentLocation
      yield put({
        type: Types.SET_CURRENT_LOCATION,
        locationObj,
      });
      // set as latest recent_location.
      yield put({
        type: Types.SET_RECENT_LOCATION,
        locationObj,
      });
    }
  } catch (e) {
    yield put({ type: Types.FETCH_GEO_LOCATION_DETAILS_FAILURE });
    console.log("error: ", e);
  }
}

export function* doGetRecentLocations(action) {
  try {
    const response = yield call(getRecentLocations, action.params);
    yield put({
      type: Types.FETCH_RECENT_LOCATIONS_SUCCESS,
      response,
    });
  } catch (e) {
    yield put({ type: Types.FETCH_RECENT_LOCATIONS_FAILURE });
    console.log("error: ", e);
  }
}

export function* doPostRecentLocation(action) {
  try {
    const response = yield call(postRecentLocation, action.locationObj);
    yield put({
      type: Types.SET_RECENT_LOCATION_SUCCESS,
      response,
    });
  } catch (e) {
    yield put({ type: Types.SET_RECENT_LOCATION_FAILURE });
    console.log("error: ", e);
  }
}

export function* doIpLookup() {
  try {
    const response = yield call(getIpLocation);

    const privateIp = !response.city || !response.zip;
    const testingEnv = process.env.REACT_APP_ENV !== "production";

    const testingLocation = {
      city: "The Office",
      zip: 84119,
      latitude: "40.7181",
      longitude: "-111.9201",
    };

    // Fail on private networks
    if (privateIp && !testingEnv) {
      yield put({
        type: Types.FETCH_IP_FAILURE,
      });
    } else {
      const formattedResponse = {
        name: `${response.city || testingLocation.city}, ${response.zip || testingLocation.zip}`,
        lat: response.latitude || testingLocation.latitude,
        lon: response.longitude || testingLocation.longitude,
      };
      setCookie(IP_LOCATION_COOKIE, JSON.stringify(formattedResponse), 14);

      const languageCookie = getCookie(LANGUAGE_COOKIE);
      if (!languageCookie) {
        const languageFromLocation = getLanguageFromLocation({
          country: response.country_code,
          state_region: response.region_code,
        });

        yield put(updateLanguage({ language: languageFromLocation }));
      }

      yield put({
        type: Types.FETCH_IP_SUCCESS,
        location: formattedResponse,
      });
    }
  } catch (e) {
    yield put({
      type: Types.FETCH_IP_FAILURE,
    });
    console.log("error: ", e);
  }
}
